<template>
  <b-modal
    v-if="shouldShowModal"
    :id="'modal-show-info-' + product.id"
    hide-footer
    hide-header
    modal-class="info-popup-v2"
  >
    <div class="product-info-modal">
      <!-- Close Button - Inside modal, top right corner -->
      <button
        class="product-info-close"
        @click="$bvModal.hide('modal-show-info-' + product.id)"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line
            x1="18"
            y1="6"
            x2="6"
            y2="18"
          />
          <line
            x1="6"
            y1="6"
            x2="18"
            y2="18"
          />
        </svg>
      </button>
      <div
        class="product-info-image"
        :style="{
          background: product.image
            ? transformColor[product.color.toLowerCase()] || product.color
            : 'linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%)',
        }"
      >
        <img
          v-if="product.image"
          :src="product.image"
          :alt="product.name"
        >
        <div
          v-else
          class="product-info-placeholder"
        >
          <svg
            class="product-placeholder-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <rect
              x="3"
              y="3"
              width="18"
              height="18"
              rx="2"
              ry="2"
            />
            <circle
              cx="8.5"
              cy="8.5"
              r="1.5"
            />
            <polyline points="21 15 16 10 5 21" />
          </svg>
        </div>
      </div>
      <div class="product-info-body">
        <h5>{{ displayName }}</h5>
        <div
          v-if="shouldShowDescription"
          class="product-info-description"
        >
          {{ product.description }}
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { shouldShowProductDescription } from '@/helpers/productDescriptionHelper';

export default {
  name: "ProductInfoModal",
  props: {
    product: {
      type: Object,
      required: true,
    },
    transformColor: {
      type: Object,
      default: () => ({}),
    },
    displayName: {
      type: String,
      required: true,
    },
  },
  computed: {
    shouldShowModal() {
      /**
       * Don't render the modal at all if description contains "type": "alert"
       * This prevents the modal from being accessible from anywhere (including cart)
       */
      return shouldShowProductDescription(this.product.description);
    },
    shouldShowDescription() {
      return shouldShowProductDescription(this.product.description);
    },
  },
};
</script>

<style >
.info-popup-v2 .modal-dialog {
  max-width: 500px;
  overflow: visible !important;
  position: relative;
}

.info-popup-v2 .modal-content {
  border: none;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  position: relative !important;
  padding: 0;
}

.info-popup-v2 .modal-body {
  background: white;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

.info-popup-v2 .modal-backdrop {
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 1;
}

.product-info-modal {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Close button inside modal, top right corner */
.product-info-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  padding: 8px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border-radius: 50%;
  color: #6B7280;
  border: 1px solid rgba(229, 231, 235, 0.8);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  margin: 0;
}

.product-info-close:hover {
  color: #EF4444;
  border-color: #EF4444;
  background: rgba(254, 226, 226, 0.95);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
}

.product-info-close:active {
  transform: scale(0.95);
}

.product-info-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0;
  padding: 0;
  border-radius: 16px 16px 0 0;
}

.product-info-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.product-info-placeholder::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    rgba(255, 255, 255, 0.1) 10px,
    rgba(255, 255, 255, 0.1) 20px
  );
  opacity: 0.3;
}

.product-info-placeholder .product-placeholder-icon {
  width: 64px;
  height: 64px;
  color: #9ca3af;
  position: relative;
  z-index: 1;
  opacity: 0.6;
}

.product-info-body {
  padding: 20px;
}

.product-info-body h5 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #111827;
}

.product-info-description {
  color: #6b7280;
  line-height: 1.6;
}
</style>
